// extracted by mini-css-extract-plugin
export default {"content":"scs8BZQP"};